import { useEvent } from 'effector-react';
import {
  getIsMenuItemExpandedFx,
  getMenuItemByIdFx,
  toggleExpandItemFx,
} from '@nx-frontend/shared/store/feature-menu-tree';
import { isSectionMenuItemType, MenuType } from '@nx-frontend/shared/types';

export function useSidebarDragOver() {
  const [getMenuItemById, getIsMenuItemExpanded, toggleExpandItem] = useEvent([
    getMenuItemByIdFx,
    getIsMenuItemExpandedFx,
    toggleExpandItemFx,
  ]);
  return async (id: string, menuType: MenuType) => {
    const item = await getMenuItemById({ id, menuType });
    const isExpanded = await getIsMenuItemExpanded({ id });
    if (item && isSectionMenuItemType(item) && !isExpanded) {
      toggleExpandItem({ item, menuType });
    }
  };
}
